import { CastType } from '@/types/casts'
import firebase from 'firebase/app'
import PlainCastAPI from './PlainCastAPI'
import SwitcherCastAPI from './SwitcherCastAPI'
import FanRoomCastAPI from './FanRoomCastAPI'
import StationSwitcherCastAPI from './StationSwitcherCastAPI'


function getCastApiByCastType (castType: CastType, db: firebase.firestore.Firestore):
      PlainCastAPI|SwitcherCastAPI|FanRoomCastAPI|StationSwitcherCastAPI {
  switch (castType) {
    case CastType.Plain: return new PlainCastAPI(db)
    case CastType.Switcher: return new SwitcherCastAPI(db)
    case CastType.FanRoom: return new FanRoomCastAPI(db)
    case CastType.StationSwitcher: return new StationSwitcherCastAPI(db)
  }
}

export {
  getCastApiByCastType
}
